import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import CategoryPageLayout from 'ui/layouts/CategoryPageLayout';

import s from './ResourcePageLayout.module.scss';

const cx = cn.bind(s);

const headerData = {
  title: 'Resources',
  info:
    'We’ve developed many tools and assessments to help you explore how your personality traits affect various aspects of your life.',
};

const ResourcePageLayout = ({
  children, className, headerTitle, headerInfo, headerContent, title, ...attrs
}) => (
  <div className={cx('wrapper')}>
    <CategoryPageLayout
      title={title}
      headerTitle={headerTitle || headerData.title}
      headerInfo={headerInfo || headerData.info}
      headerContent={headerContent}
      className={className}
      {...attrs}
    >
      { children }
    </CategoryPageLayout>
  </div>
);

ResourcePageLayout.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default ResourcePageLayout;
